const API_BASE_URL =
    // import.meta.env.VITE_API_URL || "http://127.0.0.1:8000";
    import.meta.env.VITE_API_URL || "http://api.codebytz.com";

const API_URL = `${API_BASE_URL}/api`;

export default API_URL;